import React, { useState, useEffect } from 'react'
import {
  Grid,
  FormControl,
  FormControlLabel,
  Button,
  RadioGroup,
  Radio,
  TextField,
  // CircularProgress,
} from '@material-ui/core'
import Moment from 'moment'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'
import { useFormik } from 'formik'
// import { useHistory } from 'react-router-dom'
import Stack from '@mui/material/Stack'
import '../../Elegibilidad/Style/crearFormularioElegibilidad.scss'
import Table61 from './Tables/TablesSec6/Table61'
// import { useAuthentication } from '../../../../../context/authenticationContext'

// eslint-disable-next-line no-unused-vars
// import { saveDrafElegibilityForm } from '../../../../../services/Elegibilidad/create'
// import { UpdateEnviromentalManagementPlan } from '../../../../../services/Elegibilidad/put'
import {
  // validateSubmitForm,
  getManagementPlanList,
  getManagementPlanMitigationsIsTherePlanMitigations,
} from '../../../../services/Elegibilidad/get'
import { useFormElegibilidad } from '../../../../context/ElegibilidadContext'
import { useEligibility } from '../../../../context/EligibilityContext'
import WarningIcon from '@mui/icons-material/Warning'

const ElegibilidadSec6Edit = (props) => {
  const { goToStep } = props
  const { EligibilityForm } = useFormElegibilidad()
  const [state, dispatch] = useEligibility()
  const [actionPlan, setActionPlan] = useState(true)

  const previous = () => {
    dispatch({ type: 'SET_STATE', payload: 5 })
    goToStep(5)
  }

  useEffect(() => {
    let mounted = true
    if (state.step === 6 && !formik.values.Ready) {
      try {
        getManagementPlanList(EligibilityForm.IdElegibilityAnswer).then(
          (response) => {
            if (response.Success) {
              const data = response.Data
              if (mounted) {
                formik.setValues({
                  Acc1: data[0].IsCheck,
                  Acc2: data[1].IsCheck,
                  Acc3: data[2].IsCheck,
                  Acc4: data[3].IsCheck,
                  Acc5: data[4].IsCheck,
                  Acc6: data[5].IsCheck,
                  Acc7: data[6].IsCheck,
                  Acc8: data[7].IsCheck,
                  Acc9: data[8].IsCheck,
                  Acc10: data[9].IsCheck,
                  Acc11: data[10].IsCheck,
                  Acc12: data[11].IsCheck,
                  Acc13: data[12].IsCheck,
                  Acc14: data[13].IsCheck,
                  Acc15: data[14].IsCheck,
                  Acc16: data[15].IsCheck,
                  Ready: true,
                })
              }
            }
          },
        )
      } catch (error) {
        console.log(error.message)
      }
    }

    return () => {
      mounted = false
    }
  }, [state.step])

  const enviromentalImpactText = {
    Acc1: '1.- ¿Su proyecto contamina el aire?',
    Acc2: '2.- ¿Su proyecto incrementa los niveles de ruido?',
    Acc3: '3.- ¿Su proyecto genera malos olores?',
    Acc4: '4.- ¿Su proyecto contamina el agua por falta de saneamiento básico?',
    Acc5: '5.- ¿Su proyecto disminuye el recurso del agua?',
    Acc6: '6.- Con el desarrollo del proyecto, ¿hará sedimentación de cursos de agua?',
    Acc7: '7.- ¿Su proyecto provoca contaminación por derrames de combustibles o lubricantes?',
    Acc8: '8.- ¿Con el proyecto se perderá capa orgánica? (pérdida de las capas u horizontes superiores de suelo, que contienen materia orgánica y nutriente, y que reducen el rendimiento de las cosechas en los suelos degradados.)',
    Acc9: '9.- ¿Con su proyecto se provocará erosión y sedimentación en el suelo?',
    Acc10:
      '10.- ¿Con su proyecto habrá pérdida de los recursos biológicos, incluyen los recursos madereros, acuáticos y recursos animales y vegetales (como ganado, huertos, cultivos y animales silvestres), hongos y bacterias?',
    Acc11:
      '11.- ¿Con su proyecto habrá daños o pérdidas al patrimonio cultural, que pueden incluir cualquier número de materiales, objetos o sitios que sean considerados de gran importancia cultural o histórica para las personas?',
    Acc12:
      '12.- ¿Con su proyecto habrá efectos en la salud de las personas por accidentes laborales o eventos naturales?',
    Acc13:
      '13.- ¿Con su proyecto se provocará efectos en la salud de las personas y proliferación de vectores y roedores por la presencia inadecuada de residuos (sólidos, líquidos y/o gaseosos)?',
    Acc14:
      '14.- ¿Con su proyecto se provocará efectos en la salud de las personas por presencia inadecuada de residuos líquidos (aguas residuales), potenciales de contaminación?',
    Acc15:
      '15.- ¿Considera que con su proyecto podría provocar ineficiencia en el consumo de energía?',
    Acc16:
      '16.- ¿Considera que con su proyecto habrá riesgo de exposición de sustancias peligrosas por parte de los empleados / asociados?',
  }

  const formik = useFormik({
    validateOnChange: false,
    initialValues: {
      Acc1: null,
      Acc2: null,
      Acc3: null,
      Acc4: null,
      Acc5: null,
      Acc6: null,
      Acc7: null,
      Acc8: null,
      Acc9: null,
      Acc10: null,
      Acc11: null,
      Acc12: null,
      Acc13: null,
      Acc14: null,
      Acc15: null,
      Acc16: null,
      Ready: false,
      validateTable1: true,
      validateTable2: true,
      validateTable3: true,
      validateTable4: true,
      validateTable5: true,
      validateTable6: true,
      validateTable7: true,
      validateTable8: true,
      validateTable9: true,
      validateTable10: true,
      validateTable11: true,
      validateTable12: true,
      validateTable13: true,
      validateTable14: true,
      validateTable15: true,
      validateTable16: true,
    },
  })

  const getIfiPlan = async () => {
    try {
      const response = await getManagementPlanMitigationsIsTherePlanMitigations(
        EligibilityForm.IdElegibilityAnswer,
      )
      if (response.Success) {
        setActionPlan(response.Data)
      } else {
        throw Error('Problema al obtener el plan de accion')
      }
    } catch (error) {
      console.log(error.message)
    }
  }

  useEffect(() => {
    if (
      state.step === 6 &&
      EligibilityForm.IdIFI !== undefined &&
      EligibilityForm.IdIFI !== null
    ) {
      getIfiPlan()
    }
  }, [state.step])

  return (
    <>
      <form id="eligibility-sec-6">
        <Grid item xs={12} sm={12} md={12}>
          <h1 className="h1text">Plan de Gestión Ambiental y Social</h1>
          <br />
        </Grid>
        {!actionPlan ? (
          <Grid item xs={12} sm={12} md={12}>
            <h4>
              <WarningIcon color="warning" fontSize="large" />
              La Institución Financiera Intermediaria cuenta con un Plan de
              Gestión Ambiental y Social
            </h4>
            <br />
          </Grid>
        ) : (
          <div>
            <WrapedAccordion
              formikTouched={formik.touched.Acc1}
              formikError={formik.errors.Acc1}
              acordionCheck={formik.values.Acc1}
              // toogleAcordion3={toogleAcordion3}
              idEnviromentalImpact={1}
              enviromentalImpactText={enviromentalImpactText.Acc1}
              formikSetFielValues={formik.setFieldValue}
              formikErrorTable={formik.errors.validateTable1}
            />
            <WrapedAccordion
              formikTouched={formik.touched.Acc2}
              formikError={formik.errors.Acc2}
              acordionCheck={formik.values.Acc2}
              // toogleAcordion3={toogleAcordion3}
              idEnviromentalImpact={2}
              enviromentalImpactText={enviromentalImpactText.Acc2}
              formikSetFielValues={formik.setFieldValue}
              formikErrorTable={formik.errors.validateTable2}
            />
            <WrapedAccordion
              formikTouched={formik.touched.Acc3}
              formikError={formik.errors.Acc3}
              acordionCheck={formik.values.Acc3}
              // toogleAcordion3={toogleAcordion3}
              idEnviromentalImpact={3}
              enviromentalImpactText={enviromentalImpactText.Acc3}
              formikSetFielValues={formik.setFieldValue}
              formikErrorTable={formik.errors.validateTable3}
            />
            <WrapedAccordion
              formikTouched={formik.touched.Acc4}
              formikError={formik.errors.Acc4}
              acordionCheck={formik.values.Acc4}
              // toogleAcordion3={toogleAcordion3}
              idEnviromentalImpact={4}
              enviromentalImpactText={enviromentalImpactText.Acc4}
              formikSetFielValues={formik.setFieldValue}
              formikErrorTable={formik.errors.validateTable4}
            />
            <WrapedAccordion
              formikTouched={formik.touched.Acc5}
              formikError={formik.errors.Acc5}
              acordionCheck={formik.values.Acc5}
              // toogleAcordion3={toogleAcordion3}
              idEnviromentalImpact={5}
              enviromentalImpactText={enviromentalImpactText.Acc5}
              formikSetFielValues={formik.setFieldValue}
              formikErrorTable={formik.errors.validateTable5}
            />
            <WrapedAccordion
              formikTouched={formik.touched.Acc6}
              formikError={formik.errors.Acc6}
              acordionCheck={formik.values.Acc6}
              // toogleAcordion3={toogleAcordion3}
              idEnviromentalImpact={6}
              enviromentalImpactText={enviromentalImpactText.Acc6}
              formikSetFielValues={formik.setFieldValue}
              formikErrorTable={formik.errors.validateTable6}
            />
            <WrapedAccordion
              formikTouched={formik.touched.Acc7}
              formikError={formik.errors.Acc7}
              acordionCheck={formik.values.Acc7}
              // toogleAcordion3={toogleAcordion3}
              idEnviromentalImpact={7}
              enviromentalImpactText={enviromentalImpactText.Acc7}
              formikSetFielValues={formik.setFieldValue}
              formikErrorTable={formik.errors.validateTable7}
            />
            <WrapedAccordion
              formikTouched={formik.touched.Acc8}
              formikError={formik.errors.Acc8}
              acordionCheck={formik.values.Acc8}
              // toogleAcordion3={toogleAcordion3}
              idEnviromentalImpact={8}
              enviromentalImpactText={enviromentalImpactText.Acc8}
              formikSetFielValues={formik.setFieldValue}
              formikErrorTable={formik.errors.validateTable8}
            />
            <WrapedAccordion
              formikTouched={formik.touched.Acc9}
              formikError={formik.errors.Acc9}
              acordionCheck={formik.values.Acc9}
              // toogleAcordion3={toogleAcordion3}
              idEnviromentalImpact={9}
              enviromentalImpactText={enviromentalImpactText.Acc9}
              formikSetFielValues={formik.setFieldValue}
              formikErrorTable={formik.errors.validateTable9}
            />
            <WrapedAccordion
              formikTouched={formik.touched.Acc10}
              formikError={formik.errors.Acc10}
              acordionCheck={formik.values.Acc10}
              // toogleAcordion3={toogleAcordion3}
              idEnviromentalImpact={10}
              enviromentalImpactText={enviromentalImpactText.Acc10}
              formikSetFielValues={formik.setFieldValue}
              formikErrorTable={formik.errors.validateTable10}
            />

            <WrapedAccordion
              formikTouched={formik.touched.Acc11}
              formikError={formik.errors.Acc11}
              acordionCheck={formik.values.Acc11}
              // toogleAcordion3={toogleAcordion3}
              idEnviromentalImpact={11}
              enviromentalImpactText={enviromentalImpactText.Acc11}
              formikSetFielValues={formik.setFieldValue}
              formikErrorTable={formik.errors.validateTable11}
            />

            <WrapedAccordion
              formikTouched={formik.touched.Acc12}
              formikError={formik.errors.Acc12}
              acordionCheck={formik.values.Acc12}
              // toogleAcordion3={toogleAcordion3}
              idEnviromentalImpact={12}
              enviromentalImpactText={enviromentalImpactText.Acc12}
              formikSetFielValues={formik.setFieldValue}
              formikErrorTable={formik.errors.validateTable12}
            />

            <WrapedAccordion
              formikTouched={formik.touched.Acc13}
              formikError={formik.errors.Acc13}
              acordionCheck={formik.values.Acc13}
              // toogleAcordion3={toogleAcordion3}
              idEnviromentalImpact={13}
              enviromentalImpactText={enviromentalImpactText.Acc13}
              formikSetFielValues={formik.setFieldValue}
              formikErrorTable={formik.errors.validateTable13}
            />

            <WrapedAccordion
              formikTouched={formik.touched.Acc14}
              formikError={formik.errors.Acc14}
              acordionCheck={formik.values.Acc14}
              // toogleAcordion3={toogleAcordion3}
              idEnviromentalImpact={14}
              enviromentalImpactText={enviromentalImpactText.Acc14}
              formikSetFielValues={formik.setFieldValue}
              formikErrorTable={formik.errors.validateTable14}
            />

            <WrapedAccordion
              formikTouched={formik.touched.Acc15}
              formikError={formik.errors.Acc15}
              acordionCheck={formik.values.Acc15}
              // toogleAcordion3={toogleAcordion3}
              idEnviromentalImpact={15}
              enviromentalImpactText={enviromentalImpactText.Acc15}
              formikSetFielValues={formik.setFieldValue}
              formikErrorTable={formik.errors.validateTable15}
            />

            <WrapedAccordion
              formikTouched={formik.touched.Acc16}
              formikError={formik.errors.Acc16}
              acordionCheck={formik.values.Acc16}
              // toogleAcordion3={toogleAcordion3}
              idEnviromentalImpact={16}
              enviromentalImpactText={enviromentalImpactText.Acc16}
              formikSetFielValues={formik.setFieldValue}
              formikErrorTable={formik.errors.validateTable16}
            />
            <Grid container spacing={1} className="input__container">
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  Responsable plan de acción
                </label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl style={{ width: '100%' }}>
                  <TextField
                    id="ActionPlanManager"
                    style={{ width: '100%' }}
                    // error={formHelper.errors.ActionPlanManager}
                    variant="outlined"
                    inputProps={{ maxLength: 60 }}
                    // onChange={(e) => {
                    //   formHelper.setFieldValue('ActionPlanManager', e.target.value)
                    // }}
                    disabled
                    value={EligibilityForm.ActionPlanManager}
                  />
                </FormControl>
              </Grid>
            </Grid>
          </div>
        )}

        <Grid container spacing={1} className="input__container">
          <Grid item xs={12} sm={12} md={12}>
            <label className="responsiveLabel">
              Usuario registra formulario
            </label>
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            <FormControl style={{ width: '100%' }}>
              <TextField
                id="UserName"
                style={{ width: '100%' }}
                // error={formHelper.errors.UserName}
                variant="outlined"
                disabled
                value={EligibilityForm.FormCreatedBy || ''}
              />
            </FormControl>
          </Grid>
        </Grid>

        <Grid container spacing={1} className="input__container">
          <Grid item xs={12} sm={12} md={12}>
            <label className="responsiveLabel">Fecha de presentación</label>
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <FormControl style={{ width: '100%' }}>
              <Stack component="form" noValidate spacing={3}>
                <TextField
                  id="PresentationDate"
                  name="PresentationDate"
                  type="date"
                  variant="outlined"
                  // defaultValue={valueDate.someDate}
                  sx={{ width: 220 }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={Moment(EligibilityForm.PresentationDate).format(
                    'YYYY-MM-DD',
                  )}
                  disabled
                />
              </Stack>
            </FormControl>
          </Grid>
        </Grid>

        <Grid container spacing={1}>
          <Grid container spacing={1} className="button__container">
            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              style={{ textAlign: 'left' }}
              className="continerButtonNav"
            >
              <Button
                onClick={() => previous()}
                variant="contained"
                className="button__wizard button__previous"
                // disabled={loading}
              >
                Anterior
              </Button>
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              style={{ textAlign: 'right' }}
              className="continerButtonNav"
            >
              <Grid container spacing={1} className="general_button">
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  style={{ textAlign: 'right' }}
                ></Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </>
  )
}

const WrapedAccordion = React.memo((props) => {
  const {
    // formikError,
    acordionCheck,
    // toogleAcordion3,
    idEnviromentalImpact,
    enviromentalImpactText,
    // formikSetFielValues,
    // formikErrorTable,
  } = props

  return (
    <>
      <Accordion
        id={'Acc' + idEnviromentalImpact}
        expanded={acordionCheck || false}
        defaultExpanded={false}
      >
        <AccordionSummary
          // expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Grid item xs={8} sm={8} md={8}>
            <Typography>{enviromentalImpactText}</Typography>
          </Grid>
          <Grid item xs={4} sm={4} md={4}>
            <FormControl
              style={{
                width: '100%',
                marginTop: '0',
                paddingTop: '0',
                alignItems: 'center',
              }}
            >
              <RadioGroup
                id="1"
                aria-labelledby="demo-radio-buttons-group-label"
                name="radio-buttons-group"
                row
                value={
                  acordionCheck === null ? '' : acordionCheck ? 'si' : 'no'
                }
                // onChange={(e) => toogleAcordion3(idEnviromentalImpact, e)}
              >
                <FormControlLabel
                  value="si"
                  disabled
                  control={<Radio />}
                  label="Si"
                />
                <FormControlLabel
                  value="no"
                  disabled
                  control={<Radio />}
                  label="No"
                />
              </RadioGroup>
            </FormControl>
          </Grid>
        </AccordionSummary>
        <AccordionDetails>
          <Grid item xs={8} sm={8} md={8}></Grid>
          {acordionCheck && (
            <Table61
              idEnviromentalImpact={idEnviromentalImpact}
              // formikSetFielValues={formikSetFielValues}
              acordionCheck={acordionCheck}
            />
          )}
        </AccordionDetails>
      </Accordion>
    </>
  )
})
WrapedAccordion.displayName = 'Accordion'

export default ElegibilidadSec6Edit
